import { Directive, ElementRef } from "@angular/core";

@Directive({
    selector: 'img',
    standalone: true
})
export class LazyImageDirective {
  constructor({ nativeElement }: ElementRef<HTMLImageElement>) {
    const loadingAttribute = 'loading' in HTMLImageElement.prototype;

    if (loadingAttribute)
      nativeElement.setAttribute('loading', 'lazy');
  }
}
